var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "margin-left": "25px", "margin-right": "25px" }
    }),
    _vm._v(" "),
    _c("table", [
      _c("tr", [
        _vm._m(1),
        _vm._v(" "),
        _c("td", [
          _vm.edit == false
            ? _c("div", [
                _c("p", { staticClass: "textfield" }, [
                  _vm._v(_vm._s(_vm.username))
                ])
              ])
            : _c("div", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.username,
                      expression: "username"
                    }
                  ],
                  staticClass: "textfield",
                  attrs: { id: "username", type: "username" },
                  domProps: { value: _vm.username },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.username = $event.target.value
                    }
                  }
                })
              ])
        ])
      ]),
      _vm._v(" "),
      _vm.edit == true
        ? _c("tr", [
            _vm._m(2),
            _vm._v(" "),
            _c("td", [
              _c("div", { staticClass: "textfield" }, [
                _c(
                  "button",
                  {
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.change_password()
                      }
                    }
                  },
                  [_vm._v("Change Password")]
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("tr", [
        _vm._m(3),
        _vm._v(" "),
        _c("td", [
          _c("div", [
            _c("p", { staticClass: "textfield" }, [_vm._v(_vm._s(_vm.userid))])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("tr", [
        _vm._m(4),
        _vm._v(" "),
        _c("td", [
          _vm.edit == false
            ? _c("div", [
                _c("p", { staticClass: "textfield" }, [
                  _vm._v(_vm._s(_vm.sessionend))
                ])
              ])
            : _c("div", [
                _c("b", { staticClass: "textfield" }, [_vm._v("Remember me")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.remember,
                      expression: "remember"
                    }
                  ],
                  staticClass: "textfield",
                  staticStyle: { width: "40px" },
                  attrs: { id: "remember", type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.remember)
                      ? _vm._i(_vm.remember, null) > -1
                      : _vm.remember
                  },
                  on: {
                    click: function($event) {
                      return _vm.change_session()
                    },
                    change: function($event) {
                      var $$a = _vm.remember,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.remember = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.remember = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.remember = $$c
                      }
                    }
                  }
                })
              ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "field" }, [
      _c(
        "button",
        {
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.edit_change()
            }
          }
        },
        [
          _vm.edit == false
            ? _c("div", [_vm._v("Edit")])
            : _c("div", [_vm._v("Save")])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "field" }, [
      _c("p", { staticClass: "title" }, [_vm._v("User")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticStyle: { "border-right": "solid 1px #d0d0d0" } }, [
      _c("b", { staticClass: "textlabel" }, [_vm._v("Username")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticStyle: { "border-right": "solid 1px #d0d0d0" } }, [
      _c("b", { staticClass: "textlabel" }, [_vm._v("Password")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticStyle: { "border-right": "solid 1px #d0d0d0" } }, [
      _c("b", { staticClass: "textlabel" }, [_vm._v("User ID")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticStyle: { "border-right": "solid 1px #d0d0d0" } }, [
      _c("b", { staticClass: "textlabel" }, [_vm._v("Session Expire")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ae1ac8ec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ae1ac8ec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/file/Account.vue
// module id = 496
// module chunks = 0